import { Component, OnInit } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";


@Component({
    selector: "i-icon-dialog",
    templateUrl: "../../../html/incs/i-dialog.html"
})
export class IIconDialog implements OnInit {
    public infoMessage:string = null!;

    constructor(public dialogRef: MatDialogRef<IIconDialog>,
    ) {}

    ngOnInit(): void {
    }

    closeDialog() {
      this.dialogRef.close(null!);
    }
}